<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="loanDetailPlans">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลแผนการโอนเงิน</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus" @click="openLoanDetailPlanModal">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>วันที่</vs-th>
              <vs-th>ประเภท</vs-th>
              <vs-th>จำนวนเงินที่ต้องโอน</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td class="text-center">{{ data.length - index }}</vs-td>
                <vs-td class="text-center">{{ row.loanDate }}</vs-td>
                <vs-td class="text-center">{{ row.loanDetailTypeName }}</vs-td>
                <vs-td class="text-right">{{ row.amount | numberFormat }}</vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="ลบข้อมูลแผนการโอนเงิน">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" class="ml-1" @click="onPressedDelLoanPlanDetail(row.id)"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <vs-popup :active.sync="loanDetailPlanModal.active" title="เพิ่มข้อมูลแผนการโอนเงิน" class="custom-popup">
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="loanDetailPlanForm">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }">
                  <label class="text-sm">วันที่*</label>
                  <flat-pickr :config="configLoanDate" class="w-full" v-model="loanDetailPlanModal.loanDate"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }">
                  <label class="text-sm">จำนวน*</label>
                  <vs-input type="number" class="w-full" v-model="loanDetailPlanModal.amount"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider name="ประเภท" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">ประเภท*</label>
                  <v-select v-model="loanDetailPlanModal.loanDetailType" :clearable="false" :options="loanDetailTypesOptions" :reduce="res => res.value" name="loanDetailType" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider name="หมายเหตุ" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">หมายเหตุ*</label>
                  <vs-textarea v-model="loanDetailPlanModal.remark" rows="5"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptLoanDetailPlanModal">บันทึก</vs-button>
        <vs-button color="danger" @click="loanDetailPlanModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
import moment from "moment/moment";
import { Thai } from "flatpickr/dist/l10n/th";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import { ILoanDetailType } from "@/constants/interface";

const { mapActions: mapAccountingActions, mapState: mapAccountingFields } = createNamespacedHelpers('Accounting');

export default {
  name: 'LoanDetailPlanTab',
  components: {
    flatPickr,
    vSelect,
  },
  data() {
    return {
      loanDetailPlanModal: {
        active: false,
        loanDate: moment().format('DD-MM-YYYY'),
        loanDetailType: ILoanDetailType.tuitionFee,
        amount: 0,
        remark: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      loanDetailTypesOptions: 'Master/loanDetailTypesOptions',
    }),
    ...mapAccountingFields(['contractDetail', 'contractDetailLoanDetailPlans']),
    configLoanDate() {
      let minDate = null;
      if (this.contractDetail && this.contractDetail.contractLoanDate) {
        minDate = moment(this.contractDetail.contractLoanDate).add(1, 'days').format('DD-MM-YYYY');
      }

      return {
        monthSelectorType: 'static',
        allowInput: true,
        locale: Thai,
        dateFormat: 'd-m-Y',
        minDate,
      }
    },
    loanDetailPlans() {
      if (!this.contractDetailLoanDetailPlans) return [];
      return [...this.contractDetailLoanDetailPlans]
        .sort((a, b) => new Date(b.loanDate) - new Date(a.loanDate));
    },
  },
  methods: {
    ...mapAccountingActions([
      'createContractDetailLoanDetailPlan',
      'deleteContractDetailLoanDetailPlan',
    ]),
    resetLoanDetailPlanModal() {
      this.loanDetailPlanModal.active = false;
      this.loanDetailPlanModal.loanDate = moment().format('DD-MM-YYYY');
      this.loanDetailPlanModal.loanDetailType = ILoanDetailType.tuitionFee;
      this.loanDetailPlanModal.amount = 0;
      this.loanDetailPlanModal.remark = '';
    },
    openLoanDetailPlanModal() {
      this.resetLoanDetailPlanModal();
      this.loanDetailPlanModal.active = true;
    },
    async onPressedAcceptLoanDetailPlanModal() {
      const { id: contractId } = this.$route.params;
      this.$refs['loanDetailPlanForm'].validate().then(async success => {
        if (!success) {
          return;
        }

        const loanDate = this.$options.filters.convDDMMYYYYToYYYYMMDD(this.loanDetailPlanModal.loanDate.trim());
        await this.createContractDetailLoanDetailPlan({
          contractId,
          form: {
            loanDate,
            loanDetailType: this.loanDetailPlanModal.loanDetailType,
            amount: parseFloat(this.loanDetailPlanModal.amount),
            remark: this.loanDetailPlanModal.remark,
          }
        })

        this.resetLoanDetailPlanModal();
      })
    },
    async onPressedDelLoanPlanDetail(id) {
      const { id: contractId } = this.$route.params;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูลแผนการโอนเงิน',
        text: 'คุณต้องการลบข้อมูลแผนการโอนเงินใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await this.deleteContractDetailLoanDetailPlan({ id, contractId })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-actions {
  width: 100px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
